export interface BookkeepingChangeResolution {
  currency: server.dto.Currencies;
  exchangeRate: number;
}

export const resolveBookkeepingChange = async (
  newBookkeeping: server.dto.BookkeepingSmall,
  currentCurrency: server.dto.Currencies,
  currentExchangeRate: number,
  preserveCurrency: boolean,
  currentBookkeepingBaseCurrency: server.dto.Currencies
): Promise<BookkeepingChangeResolution> => {
  if (!preserveCurrency || newBookkeeping.baseCurrency === currentCurrency) {
    return {
      currency: newBookkeeping.baseCurrency,
      exchangeRate: 1,
    };
  }

  const baseCurrencyHasntChanged = currentBookkeepingBaseCurrency === newBookkeeping.baseCurrency;
  if (baseCurrencyHasntChanged) {
    return {
      currency: currentCurrency,
      exchangeRate: currentExchangeRate,
    };
  }

  const exchangeRateResponse = await window.CoreApi.Bookkeeping.GetExchangeRate({
    bookkeepingId: newBookkeeping.bookkeepingId,
    currency: currentCurrency,
  });

  return {
    currency: currentCurrency,
    exchangeRate: exchangeRateResponse.data.data.rate,
  };
};
